import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { AppSettings, CompanySettings } from 'domain/shared/types/settings';
import AppSettingsService from 'domain/shared/services/app-settings-service';
import { setTranslations } from 'locales';

export const setSettings = createAsyncThunk(
  'settings/set-app-settings',
  async () => {
    const [appSettings, companySettings] = await Promise.all([
      AppSettingsService.getAppSettings(),
      AppSettingsService.getCompanySettings(),
    ]);
    
    return {
      appSettings: appSettings?.settings,
      companySettings: companySettings?.settings,
    };
  },
);

interface SettingsState {
  appSettings: AppSettings | undefined;
  companySettings: CompanySettings | undefined;
}

const initialState: SettingsState = {
  appSettings: undefined,
  companySettings: undefined,
};

const settingsSlice = createSlice({
  initialState,
  name: 'settings',
  reducers: {
    clearSettings(state) {
      state.appSettings = undefined;
      state.companySettings = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(setSettings.fulfilled, (state, action: PayloadAction<SettingsState>) => {
      const { appSettings, companySettings } = action.payload;

      // FIXME: IN THE FUTURE WE MUST CHANGE HOW THIS WORKS
      if (companySettings?.flag_company_multi_language) {
        setTranslations(companySettings.flag_company_multi_language.toLocaleUpperCase());
      }

      state.appSettings = appSettings;
      state.companySettings = companySettings;
    });
  },
});

export default settingsSlice.reducer;

export const {
  clearSettings,
} = settingsSlice.actions;
